export const useResetRouteState = (path?: string) => {
  return {
    /**
     * Resets the paths *History* state
     * @param path (relative) path, if not provided, the current path will be used
     */
    resetRouteState: () =>
      window.history.replaceState({}, '', path || undefined),
  }
}
